import React, {memo} from "react";
import PropTypes from "prop-types";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {FaTimes} from "react-icons/fa";
import Loader from "../../components/Loader";
import SimUsageForm from "../Forms/SimUsageForm";

const SimUsage = (props) => {
  const {open, onClose} = props;

  const onSubmit = () => {
    onClose();
  };

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
      <Loader />
      <div style={{float: "right"}}>
        <ModalHeader>
          <FaTimes style={{cursor: "pointer"}} onClick={() => onClose()} size={32} />
        </ModalHeader>
      </div>
      <ModalBody>
        {/*<div className="pl-lg-4">*/}
        <SimUsageForm onFormSubmit={onSubmit} />
        {/*</div>*/}
      </ModalBody>
    </Modal>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.open === nextProps.open;
}

SimUsage.propTypes = {
  open: PropTypes.bool,
};
export default memo(SimUsage, areEqual);
